import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = (isSupplyChainManager = false) => [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'asdatepos',
  },
  // {
  //   label: 'Type',
  //   value: 'wasteSource',
  // },
  // {
  //   label: 'Batch id',
  //   value: 'id',
  // },
  {
    label: 'Product',
    value: 'pospro',
  },
  {
    label: 'Batch id',
    value: 'id',
  },
  {
    label: 'qUANTITY',
    value: 'posqUANTITY',
  },
  // {
  //   label: isSupplyChainManager ? 'Supply chain' : 'Franchisee',
  //   value: 'franchiseName',
  // },
  {
    label: 'Country',
    value: 'converterCountry2',
  },
  {
    label: 'site',
    value: 'pickupPointName',
  },
  {
    label: 'Recipient',
    value: 'converterName',
  },
  {
    label: 'country',
    value: 'converterCountry',
  },
  // {
  //   label: 'Price',
  //   // value: 'price',
  //   value: 'totalAmountI',
  // },
  {
    label: 'feedstock',
    value: 'feedstockpos',
  },
  {
    label: 'GHG value',
    value: 'ghgpos',
  },
  {
    label: 'Saving',
    value: 'Savingpos',
  },
  {
    label: 'Coc',
    value: 'cocpopup',
  },
  // {
  //   label: 'Contact',
  //   value: 'customerInfo[mobile]',
  // },
  // {
  //   action: ['view'],
  // },

  // {
  //   label: 'status',
  //   value: 'isscustatus',
  // },

  {
    action: ['view'],
  },
]

const roleColumns = (isSupplyChainManager = false) => {
  return columnGenerators(header(isSupplyChainManager))
}
export { roleColumns }
